// components/mascot/types.ts
export type JibiPose = "waving" | "idle" | "peek";
export type JibiSize = "sm" | "md" | "lg" | "xl";

export interface JibiProps {
  pose?: JibiPose;
  size?: JibiSize;
  animate?: boolean;
  className?: string;
}

export const JIBI_SIZE_MAP: Record<JibiSize, number> = {
  sm: 80,
  md: 160,
  lg: 240,
  xl: 320,
};